<div id="save-work-list-modal" class="modal__content flex flex__item flex--col">
	<ng-container *ngIf="!isLoading">
		<div id="worklistName" class="flex flex--row flex--nowrap flex--top flex--justify">
			<div style="width: 30%">
				<label for="worklist-name" class="form__label label__container u-mt--- form__label--bottom">
					<span> {{'advanceSearch.worklistNameLabel' | translate}} </span>
				</label>
			</div>
			<div class="flex__item">
				<div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
					<input [(ngModel)]="config.data.searchParams.worklistName"
					       (ngModelChange)="inputValueChange('worklistName')"
					       [placeholder]="'advanceSearch.worklistNamePlaceHolderText' | translate"
					       id="worklist-name" type="text" class="textbox u-mb----"
					       [attr.aria-invalid]="!!config.data.searchParamsError.worklistName">
					<div class="filter__icon">
						<svg-icon name="ico-close-16"
						          *ngIf="config.data.searchParams.worklistName"
						          (click)="clearInputField('worklistName')"
						          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
						></svg-icon>
					</div>
				</div>
				<div class="error-content">
					<div id="search-input-worklistName-error-message" *ngIf="config.data.searchParamsError.worklistName"
					     role="alert" class="form__error-text">
						<svg-icon
							name="ico-form-error-16"
							svgClass="close-icon"
							class="u-mr---"
							[svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
						>
						</svg-icon>
						{{config.data.searchParamsError.worklistName | translate}}
					</div>
				</div>
			</div>
		</div>

		<div class="flex flex--row flex--nowrap flex--top flex--justify">
			<div style="width: 30%">
				<label for="viewer-preference" class="form__label label__container u-mt--- form__label--bottom">
					<span> {{'viewer.preferences' | translate}} </span>
				</label>
			</div>
			<div id="viewer-preference" class="flex__item">
				<label for="preference-container-viewerPreferences" class="checkbox u-mt---">
					<input [(ngModel)]="config.data.searchParams.viewerPreference"
					       name="viewerPreference" id="preference-container-viewerPreferences" type="checkbox"
					       class="checkbox__input">
					<span class="checkbox__label">{{'advanceSearch.preferenceViewerLaunchLabel' | translate}}</span>
				</label>
			</div>
		</div>

		<div class="flex" *ngIf="config.data.isLinkedList">
			<div style="width: 30%"></div>
			<div id="linked-worklist-msg" class="flex flex--row flex--nowrap flex--top flex--justifyng">
				<div style="margin-top: 2px;">
					<svg-icon name="ico-link-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
					></svg-icon>
				</div>
				<div class="u-ml---">
					<label for="linked-worklist-msg" class="checkbox">
						<span> {{'searchModule.sourceworklistMsg' | translate}} </span>
					</label>
				</div>

			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="isLoading">
		<div class="flex flex--row flex--nowrap flex--center flex--middle spinner">
			<wfm-spinner size="40"></wfm-spinner>
		</div>
	</ng-container>
</div>

<div class="modal__footer">
	<button type="button" class="button button--primary button--accept text-ellipsis display-inline-block"
	        id="work-list-save-btn" tabindex="1"
	        [innerHTML]="'label.save' | translate"
	        (click)="save(); $event.stopPropagation()"
	        [disabled]="!config.data.searchParams.worklistName || config.data.searchParamsError.worklistName"></button>
	<button type="button" class="button button--tertiary button--reject text-ellipsis display-inline-block"
	        id="work-list-cancel-btn" tabindex="2"
	        [innerHTML]="'label.cancel' | translate"
	        (click)="cancel(); $event.stopPropagation()"></button>
</div>
